import { defineComponent as _defineComponent } from 'vue'
import { ReceiptPageHeadPreloader } from 'ecommerce/feature-receipt-header';
import { IconWrapper } from 'ui-shared-components';

type Props = {
  title?: string
  subtitle?: string
  contentLoading?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-booking-receipt-info-header',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    contentLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string, contentLoading: boolean };


const IconCheck = () => import('@white-label-icon/icon-check')



return { __sfc: true,IconCheck, props, ReceiptPageHeadPreloader, IconWrapper }
}

})